var map = {
	"./ion-action-sheet-controller_8.entry.js": [
		"0BR9",
		0,
		42
	],
	"./ion-action-sheet-ios.entry.js": [
		"bnjm",
		0,
		43
	],
	"./ion-action-sheet-md.entry.js": [
		"utt2",
		0,
		44
	],
	"./ion-alert-ios.entry.js": [
		"yaSn",
		0,
		45
	],
	"./ion-alert-md.entry.js": [
		"2/RY",
		0,
		46
	],
	"./ion-app_8-ios.entry.js": [
		"iInF",
		0,
		47
	],
	"./ion-app_8-md.entry.js": [
		"K9Nc",
		0,
		48
	],
	"./ion-avatar_3-ios.entry.js": [
		"hH1s",
		0,
		49
	],
	"./ion-avatar_3-md.entry.js": [
		"Jw9y",
		0,
		50
	],
	"./ion-back-button-ios.entry.js": [
		"ouVF",
		0,
		51
	],
	"./ion-back-button-md.entry.js": [
		"/joy",
		0,
		52
	],
	"./ion-backdrop-ios.entry.js": [
		"uJLv",
		53
	],
	"./ion-backdrop-md.entry.js": [
		"fSmE",
		54
	],
	"./ion-button_2-ios.entry.js": [
		"s1jK",
		0,
		55
	],
	"./ion-button_2-md.entry.js": [
		"Wou7",
		0,
		56
	],
	"./ion-card_5-ios.entry.js": [
		"qshq",
		0,
		57
	],
	"./ion-card_5-md.entry.js": [
		"Q1uX",
		0,
		58
	],
	"./ion-checkbox-ios.entry.js": [
		"059i",
		0,
		59
	],
	"./ion-checkbox-md.entry.js": [
		"eLfv",
		0,
		60
	],
	"./ion-chip-ios.entry.js": [
		"+FzG",
		0,
		61
	],
	"./ion-chip-md.entry.js": [
		"yRpg",
		0,
		62
	],
	"./ion-col_3.entry.js": [
		"/CAe",
		63
	],
	"./ion-datetime_3-ios.entry.js": [
		"Z1Jy",
		0,
		64
	],
	"./ion-datetime_3-md.entry.js": [
		"X0Dk",
		0,
		65
	],
	"./ion-fab_3-ios.entry.js": [
		"wvyA",
		0,
		66
	],
	"./ion-fab_3-md.entry.js": [
		"NkKY",
		0,
		67
	],
	"./ion-img.entry.js": [
		"wHD8",
		68
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		"nf6t",
		0,
		69
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		"lg/V",
		0,
		70
	],
	"./ion-input-ios.entry.js": [
		"sdJS",
		0,
		71
	],
	"./ion-input-md.entry.js": [
		"uQUw",
		0,
		72
	],
	"./ion-item-option_3-ios.entry.js": [
		"Pa1g",
		0,
		73
	],
	"./ion-item-option_3-md.entry.js": [
		"KTnd",
		0,
		74
	],
	"./ion-item_8-ios.entry.js": [
		"Z51p",
		0,
		75
	],
	"./ion-item_8-md.entry.js": [
		"8bam",
		0,
		76
	],
	"./ion-loading-ios.entry.js": [
		"J3Yu",
		0,
		77
	],
	"./ion-loading-md.entry.js": [
		"N3W9",
		0,
		78
	],
	"./ion-menu_4-ios.entry.js": [
		"GEuc",
		0,
		79
	],
	"./ion-menu_4-md.entry.js": [
		"BHpw",
		0,
		80
	],
	"./ion-modal-ios.entry.js": [
		"mgaC",
		0,
		81
	],
	"./ion-modal-md.entry.js": [
		"EpFf",
		0,
		82
	],
	"./ion-nav_5.entry.js": [
		"qF1+",
		0,
		83
	],
	"./ion-popover-ios.entry.js": [
		"Gdks",
		0,
		84
	],
	"./ion-popover-md.entry.js": [
		"VgKV",
		0,
		85
	],
	"./ion-progress-bar-ios.entry.js": [
		"0PGG",
		0,
		86
	],
	"./ion-progress-bar-md.entry.js": [
		"h/Bu",
		0,
		87
	],
	"./ion-radio_2-ios.entry.js": [
		"5bK7",
		0,
		88
	],
	"./ion-radio_2-md.entry.js": [
		"pOmE",
		0,
		89
	],
	"./ion-range-ios.entry.js": [
		"5g9+",
		0,
		90
	],
	"./ion-range-md.entry.js": [
		"fD4w",
		0,
		91
	],
	"./ion-refresher_2-ios.entry.js": [
		"CXux",
		0,
		92
	],
	"./ion-refresher_2-md.entry.js": [
		"RODS",
		0,
		93
	],
	"./ion-reorder_2-ios.entry.js": [
		"IdzL",
		0,
		94
	],
	"./ion-reorder_2-md.entry.js": [
		"Ftzj",
		0,
		95
	],
	"./ion-ripple-effect.entry.js": [
		"STjf",
		96
	],
	"./ion-route_4.entry.js": [
		"k5eQ",
		0,
		97
	],
	"./ion-searchbar-ios.entry.js": [
		"l0q3",
		0,
		98
	],
	"./ion-searchbar-md.entry.js": [
		"mLlG",
		0,
		99
	],
	"./ion-segment_2-ios.entry.js": [
		"Iymp",
		0,
		100
	],
	"./ion-segment_2-md.entry.js": [
		"3msy",
		0,
		101
	],
	"./ion-select_3-ios.entry.js": [
		"rYLK",
		0,
		102
	],
	"./ion-select_3-md.entry.js": [
		"WOXB",
		0,
		103
	],
	"./ion-slide_2-ios.entry.js": [
		"F/Xn",
		104
	],
	"./ion-slide_2-md.entry.js": [
		"k8us",
		105
	],
	"./ion-spinner.entry.js": [
		"nI0H",
		0,
		106
	],
	"./ion-split-pane-ios.entry.js": [
		"edcM",
		107
	],
	"./ion-split-pane-md.entry.js": [
		"RyPD",
		108
	],
	"./ion-tab-bar_2-ios.entry.js": [
		"DP4G",
		0,
		109
	],
	"./ion-tab-bar_2-md.entry.js": [
		"gaXT",
		0,
		110
	],
	"./ion-tab_2.entry.js": [
		"TpdJ",
		0,
		111
	],
	"./ion-text.entry.js": [
		"ISmu",
		0,
		112
	],
	"./ion-textarea-ios.entry.js": [
		"xNZy",
		0,
		113
	],
	"./ion-textarea-md.entry.js": [
		"p1XJ",
		0,
		114
	],
	"./ion-toast-ios.entry.js": [
		"XGfm",
		0,
		115
	],
	"./ion-toast-md.entry.js": [
		"Y/uG",
		0,
		116
	],
	"./ion-toggle-ios.entry.js": [
		"WbT0",
		0,
		117
	],
	"./ion-toggle-md.entry.js": [
		"upP9",
		0,
		118
	],
	"./ion-virtual-scroll.entry.js": [
		"8Mb5",
		119
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "kLfG";
module.exports = webpackAsyncContext;